 
/* eslint-disable new-cap */
import ko from 'knockout';
import '../../../../jsscripts/jquery/knockout/knockout.mapping';
import { HTTP_STATUS_OK } from '../../../smartpak/httpstatus';
import LoadLevelingViewModel from './loadlevelingviewmodel';
import PakItemViewModel from './pakitemviewmodel';
import customerInfo from '../../../controls/customerinfo';
import { stringToDate } from '../../../utils/date';
import { roundedToFixed } from '../../../utils/number';
import * as otsTypes from '../../../constants/otstypes';

function PakViewModel(model, onUpdateCallback) {
    var mapping = {
        ScheduledShipDate: {
            create: function (options) {
                return stringToDate(options.data, null, true).toString('ddd M/d');
            }
        },
        EstimatedArrivalDate: {
            create: function (options) {
                return stringToDate(options.data, null, true).toString('ddd M/d');
            }
        },
        Cost: {
            create: function (options) {
                return roundedToFixed(options.data, 2);
            }
        },
        CustomerCareLoadLevelingMessage: {
            create: function (options) {
                return new LoadLevelingViewModel(options.data);
            }
        },
        SupplementViewModels: {
            create: function (options) {
                return new PakItemViewModel(options.data, model.AccountId);
            }
        }
    };

    ko.mapping.fromJS(model, mapping, this);

    this.thumbnail = this.IsPortionPak()
        ? '/images/portionpak-cart-thumb80x80.jpg'
        : this.IsCanineSmartPak()
            ? '/images/caninepak-cart-thumb80x80.jpg'
            : '/images/smartpak-cart-thumb-80x80.jpg';

    this.builderUrl = '/AutoShipManager/Supplements/' + this.AccountId();


    this.saveNewsterChoice = function (accountId, shouldGetNewster) {
        return $.post('/cart/SetAccountNewster', { accountId: accountId, addNewster: shouldGetNewster });
    };

    this.SmartPakShouldGetNewster.subscribe(shouldGetNewster => {
        this.saveNewsterChoice(this.AccountId(), shouldGetNewster);
    });

    this.discountedUnitPrice = ko.computed(
        function () {
            return roundedToFixed(this.DiscountedPrice(), 2);
        }.bind(this)
    );

    this.isFree = ko.computed(
        function () {
            return this.DiscountedPrice() === 0;
        }.bind(this)
    );

    this.unitPrice = roundedToFixed(this.SupplementViewModels()
        .reduce(function (seed, item) {
            return seed + item.ConditionalItemFullCharge();
        }, 0), 2);

    this.hasDiscounts =
        this.SupplementViewModels().filter(function (supplement) {
            return supplement.hasDiscounts;
        }).length > 0;

    this.discountsApplied = formatDiscounts(combineDiscounts(this.SupplementViewModels()));
    this.discountsAppliedTooltip = this.discountsApplied.length
        ? '<strong>Your savings</strong>:<br />' + this.discountsApplied.join('<br />')
        : '';
    this.discountsAppliedTitle = this.discountsApplied.length
        ? 'Your savings: ' + this.discountsApplied.join(', ')
        : '';

    this.hasColicareEligibleItem = this.SupplementViewModels().some(function (supplement) {
        return supplement.SupplementIsColiCareEligible();
    });


    this.isSpeUser = ko.observable(false);

    this.otsTypes = otsTypes;

    this.OtsType.subscribe(
        function (otsType) {
            if (!otsType) {
                this.OtsType(otsTypes.ATS);
                return;
            }

            const isAutoShip = otsType === otsTypes.ATS;
            this.IsAutoShip(isAutoShip);
            this.saveAutoShipSelection();
        }.bind(this)
    );

    this.isSaving = ko.observable(false);

    this.newsterError = ko.observable(false);

    this.onUpdateCallback = onUpdateCallback;

    if (customerInfo) {
        customerInfo.getCustomerInfo().done(function (response) {
            if (response && response.status === HTTP_STATUS_OK) {
                this.isSpeUser(response.content.isSpeUser);
            }
        }.bind(this));
    }

    this.hasConfirmation = isConfirmationPage();
}

$.extend(PakViewModel.prototype, {
    saveAutoShipSelection: async function () {
        const type = this.OtsType();
        const isServiceOTS = type === otsTypes.ServiceOTS;
        const isAutoShip = type === otsTypes.ATS;

        this.isSaving(true);

        const response = await fetch(`/api/shipping/UpdateAutoshipForSmartPak?accountId=${this.AccountId()}&isAutoShip=${isAutoShip}&isServiceOTS=${isServiceOTS}`);
        const { Status } = await response.json();

        if (
            Status === HTTP_STATUS_OK
            && typeof this.onUpdateCallback === 'function'
        ) {
            await this.onUpdateCallback();
        }

        this.isSaving(false);
    },
    // eslint-disable no-unused-vars
    addNewster: async function (data, event) {
        event.target.disabled = true;

        const errorTrigger = () => {
            event.target.disabled = false;
            this.newsterError(true);
        };

        try {
            const response = await fetch('/addtocart/' + this.BetterTogetherModel.ProductClassId() + '/AddSupply', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    Quantity: 1,
                    ProductId: this.BetterTogetherModel.ProductId(),
                    AccountName: this.AccountName()
                })
            });

            if (response.status === HTTP_STATUS_OK && this.onUpdateCallback) {
                this.onUpdateCallback();
            } else if (!response.status === HTTP_STATUS_OK && this.onUpdateCallback) {
                errorTrigger(this);
            }
        } catch {
            errorTrigger(this);
        }
    }
});


function formatDiscounts(discounts) {
    return Object.keys(discounts).map(function (key) {
        return key + ': $' + roundedToFixed(discounts[key], 2);
    });
}

function combineDiscounts(supplements) {
    return supplements.reduce(function (destination, supplement) {
        return mergeDiscounts(destination, supplement.Discounts);
    }, {});
}

function mergeDiscounts(destination, source) {
    Object.keys(source).forEach(function (key) {
        var value = +source[key]();
        if (destination[key]) {
            destination[key] = destination[key] + value;
        } else {
            destination[key] = value;
        }
    });

    return destination;
}

function isConfirmationPage() {
    const $model = document.getElementById('ConfirmationModel');
    return !!($model && $model.value);
}

export default PakViewModel;
